var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.703,
    height: 30.572,
    viewBox: "0 0 30.703 30.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_875",
    "data-name": "Raggruppa 875",
    transform: "translate(-928.648 -161.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_874",
    "data-name": "Raggruppa 874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_873",
    "data-name": "Raggruppa 873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_872",
    "data-name": "Raggruppa 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_855",
    "data-name": "Raggruppa 855",
    transform: "translate(928.648 161.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1443",
    "data-name": "Tracciato 1443",
    d: "M22.872,22.819H7.41a1.16,1.16,0,0,1,0-2.319H22.872a1.16,1.16,0,1,1,0,2.319Z",
    transform: "translate(0.216 7.753)",
    fill: "#f8ab18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1444",
    "data-name": "Tracciato 1444",
    d: "M30.336,7.318l-6.185,4.422a1.556,1.556,0,0,1-2.35-.711L18.878,3.236a1.54,1.54,0,0,0-2.891,0l-2.938,7.777a1.524,1.524,0,0,1-2.335.711L4.529,7.3A1.558,1.558,0,0,0,2.164,9.1L8.6,27.11a1.534,1.534,0,0,0,1.453,1.02H24.785a1.555,1.555,0,0,0,1.453-1.02L32.67,9.1A1.533,1.533,0,0,0,30.336,7.318ZM21.29,21.59H13.559a1.16,1.16,0,1,1,0-2.319H21.29a1.16,1.16,0,0,1,0,2.319Z",
    transform: "translate(-2.068 -2.228)",
    fill: "#f8ab18"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.b102c361a12788d07940807c5c08508a.svg";
export { ForwardRef as ReactComponent };